// extracted by mini-css-extract-plugin
module.exports = {"collapsed_box":"index-collapsed_box__3M1WX","collapsed_box--open":"index-collapsed_box--open__3Dstv"};